// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__247Te","toggle":"styles_toggle__ejPBb","preview":"styles_preview__3ruGc"};